import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../utils/format';
import { shellPoll } from './shellRead';
// 990 (R-AQ): while a temporary unlock window is active, every page says so (polled each minute; errors are silent).
export default function PeriodWindowBanner() {
  const { t } = useTranslation('common');
  const [windows, setWindows] = useState([]);
  useEffect(() => {
    let alive = true;
    // Round 1 (C8): now + each minute, skipped while the tab is hidden, never overlapping. Round 4c: the first read waits for the page's own reads.
    // Round 4e: read through the shell's one request and its one poll timer (shellPoll: after paint, 60 s, paused while hidden). Errors stay silent.
    const stop = shellPoll('period_windows', (r, err) => { if (alive && !err) setWindows(r?.windows || []); });
    return () => { alive = false; stop(); };
  }, []);
  if (!windows.length) return null;
  return <div role="status" data-testid="period-window-banner" className="notice-chip warn" style={{ display: 'block', padding: '6px 14px', fontSize: 13 }}>
    {windows.map(w => <div key={w.id}>{t('stgUi.periodOpenBanner', { date: w.lock_date, time: formatDateTime(w.expires_at) })}</div>)}
  </div>;
}
